export default "__VITE_ASSET__x3B1WNka__"